import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function Reports() {
  const navigate = useNavigate();
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [platform, setPlatform] = useState('All');
  const [dateType, setDateType] = useState('publish'); // publish | created


  const token = localStorage.getItem('token');

  // If user not authenticated, redirect to login
  React.useEffect(() => {
    if (!token) navigate('/login');
  }, []);

  const handleDownload = async () => {
    try {
      const params = {};
      if (fromDate) params.from_date = fromDate;
      if (toDate) params.to_date = toDate;
      if (platform && platform !== 'All') params.platform = platform;
      if (dateType) params.date_type = dateType;


      const token = localStorage.getItem('token');

      const response = await axios.get('/api/reports/news', {
        params,
        responseType: 'blob', // Important for file download
        headers: { Authorization: `Bearer ${token}` },
      });

      // Create a URL for the blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const filename = `media-report${fromDate ? `-${fromDate}` : '-all'}${toDate ? `_to_${toDate}` : ''}${platform && platform !== 'All' ? `-${platform}` : ''}.xlsx`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading report:', error);
      const status = error?.response?.status;
      const message = error?.response?.data?.message;
      if (status === 404 && message) {
        alert(message);
        return;
      }
      alert('Failed to download report. Please try again.');
    }
  };

  const isValid = !fromDate || !toDate || new Date(fromDate) <= new Date(toDate);

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Generate Reports</h2>
        <a href="/dashboard" className="text-indigo-600 hover:text-indigo-500">← Back to Dashboard</a>
      </div>
      <div className="bg-white shadow rounded-lg overflow-hidden max-w-2xl">
        <div className="p-8">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Media Monitoring Report</h3>
          <p className="text-gray-600 mb-6">Download filtered news data as Excel</p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Tanggal Dari</label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Tanggal Sampai</label>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">Platform</label>
            <select
              value={platform}
              onChange={(e) => setPlatform(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="All">All Platforms</option>
              <option value="Media Online">Media Online</option>
              <option value="Media Sosial">Media Sosial</option>
              <option value="Media Cetak">Media Cetak</option>
            </select>
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">Tanggal berdasarkan</label>
            <select
              value={dateType}
              onChange={(e) => setDateType(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="publish">Publish Date (publish_datetime)</option>
              <option value="created">Create Date (created_at)</option>
            </select>
          </div>


          <button
            onClick={handleDownload}
            disabled={!isValid}
            className={`py-3 px-6 rounded-lg font-medium focus:outline-none focus:ring-2 ${
              isValid
                ? 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500'
                : 'bg-gray-400 text-gray-700 cursor-not-allowed'
            }`}
          >
            Download Report (Excel){fromDate || toDate ? ` [${fromDate || '*'} to ${toDate || '*'}]` : ''}{platform && platform !== 'All' ? ` [${platform}]` : ''}
          </button>
          
          {!isValid && (
            <p className="mt-2 text-sm text-red-600">Tanggal sampai harus lebih besar atau sama dengan tanggal dari.</p>
          )}
        </div>
      </div>
    </div>
  );
}

